'use client';

import { supportDummy } from '@/mock/support-dummy';

const SupportPage = () => {
  return (
    <div className="flex h-screen w-full justify-center bg-bg-blueGreyDeep">
      <div className="w-full">
        <div className="m-10 rounded-[12px] border bg-white p-10">
          <div className="flex w-full justify-center whitespace-pre-line pb-4">
            <p className="text-lg font-bold">{supportDummy.title}</p>
          </div>
          <div className="flex w-full justify-center whitespace-pre-line pb-4">
            <p className="text-md text-center font-bold">
              {supportDummy.subtitle}
            </p>
          </div>
          <div className="flex w-full justify-center whitespace-pre-line px-10">
            <p className="text-center text-sm">{supportDummy.discription1}</p>
          </div>

          <div className="flex w-full justify-center whitespace-pre-line px-10">
            <p className="text-center text-sm text-[#999]">
              {supportDummy.discription2}
            </p>
          </div>
        </div>

        <div className="m-10">
          <div className="flex w-full justify-start whitespace-pre-line pb-2">
            <p className="text-sm">{`대표번호  ${supportDummy.callNumber}`}</p>
          </div>
          <div className="mb-2 border-b border-gray-300 px-10" />
          <div className="flex w-full justify-start whitespace-pre-line">
            <p className="text-sm">{`이메일  ${supportDummy.email}`}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
